import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMip = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.10301000000001,
			d: "M776.868 771.377V535.938c-.03-20.983-11.272-40.436-29.43-50.913l-206.009-117.72c-18.187-10.506-40.672-10.506-58.86 0l-206.008 117.72c-18.158 10.477-29.4 29.93-29.43 50.913v235.439c.03 20.983 11.272 40.436 29.43 50.913L482.57 940.01c18.187 10.506 40.672 10.506 58.86 0l206.008-117.72c18.158-10.477 29.4-29.93 29.43-50.913"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.10301000000001,
			d: "M255.077 505.331 512 653.951l256.922-148.62M512 950.31V653.658"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 1.4,
			strokeWidth: 90.18,
			d: "M13347 5366.8v-132.54",
			transform: "matrix(1 0 0 .5243 -12835 -2609.06)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 1.4,
			strokeWidth: 90.18,
			d: "M13347 5366.8v-132.54",
			transform: "matrix(.86603 -.5 .26215 .45406 -12678.2 4501.56)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 1.4,
			strokeWidth: 90.18,
			d: "M13347 5366.8v-132.54",
			transform: "matrix(.5 -.86603 .45406 .26215 -8987.1 10581.1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 1.4,
			strokeWidth: 90.18,
			d: "M13347 5366.8v-132.54",
			transform: "matrix(.86603 .5 -.26215 .45406 -9415.48 -8845.44)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 1.4,
			strokeWidth: 90.18,
			d: "M13347 5366.8v-132.54",
			transform: "matrix(.5 .86603 -.45406 .26215 -3335.9 -12536.5)"
		})
	]
});
export default SvgIconMip;
